import Head from "next/head";
import { Button } from "@/components/Button";
import { Layout } from "@/components/Layout";
import { PageTitle } from "@/components/PageTitle";
import { SectionContainer } from "@/components/SectionContainer";
import { ExternalLinkIcon } from "@heroicons/react/outline";

export default function Contact() {
  const pageTitle = "Contact";
  return (
    <>
      <Head>
        <title>{`${pageTitle} - Govern For California`}</title>
        <meta
          name="description"
          content="Contact methods for Govern For California"
        />
      </Head>
      <Layout mobileTitle={pageTitle}>
        <PageTitle title={pageTitle} />
        <SectionContainer bgColor={"bg-white"}>
          <div className="sm:my-6">
            <div className="lg:grid lg:grid-cols-3 lg:gap-8">
              <div className="grid grid-cols-1 gap-12 sm:grid-cols-2 sm:gap-x-8 sm:gap-y-12 lg:col-span-2">
                <div>
                  <h3 className="text-lg font-medium leading-6 text-gray-900">
                    General Inquiries
                  </h3>
                  <dl className="mt-2 text-base text-gray-500">
                    <div>
                      <dt className="sr-only">Email</dt>
                      <dd>
                        <a
                          className="body-link"
                          href="mailto:info@governforcalifornia.org?subject=Web Contact Inquiry: "
                        >
                          Send email
                        </a>
                      </dd>
                    </div>
                    {/* <div className="mt-1">
                      <dt className="sr-only">Phone number</dt>
                      <dd>+1 (555) 123-4567</dd>
                    </div> */}
                  </dl>
                </div>
                <div>
                  <h3 className="text-lg font-medium leading-6 text-gray-900">
                    Press
                  </h3>
                  <dl className="mt-2 text-base text-gray-500">
                    <div>
                      <dt className="sr-only">Email</dt>
                      <dd>
                        {" "}
                        <a
                          className="body-link"
                          href="mailto:pr@governforcalifornia.org?subject=Web Press Inquiry: "
                        >
                          Send email
                        </a>
                      </dd>
                    </div>
                    {/* <div className="mt-1">
                      <dt className="sr-only">Phone number</dt>
                      <dd>+1 (555) 123-4567</dd>
                    </div> */}
                  </dl>
                </div>
                {/* <div>
                  <h3 className="text-lg font-medium leading-6 text-gray-900">
                    Join our team
                  </h3>
                  <dl className="mt-2 text-base text-gray-500">
                    <div>
                      <dt className="sr-only">Email</dt>
                      <dd>support@example.com</dd>
                    </div>
                    <div className="mt-1">
                      <dt className="sr-only">Phone number</dt>
                      <dd>+1 (555) 123-4567</dd>
                    </div>
                  </dl>
                </div>
                <div>
                  <h3 className="text-lg font-medium leading-6 text-gray-900">
                    Say hello
                  </h3>
                  <dl className="mt-2 text-base text-gray-500">
                    <div>
                      <dt className="sr-only">Email</dt>
                      <dd>support@example.com</dd>
                    </div>
                    <div className="mt-1">
                      <dt className="sr-only">Phone number</dt>
                      <dd>+1 (555) 123-4567</dd>
                    </div>
                  </dl>
                </div> */}
              </div>
            </div>

            <div className="pt-8 lg:grid lg:grid-cols-3 lg:gap-8">
              {/* <h2 className="text-2xl font-bold text-gray-900 sm:text-3xl sm:tracking-tight">
                Locations
              </h2> */}
              <div className="mt-8 grid grid-cols-1 gap-12 sm:grid-cols-2 sm:gap-x-8 sm:gap-y-12 lg:col-span-2 ">
                <div>
                  <h3 className="text-lg font-medium leading-6 text-gray-900">
                    Sacramento Office
                  </h3>
                  <div className="mt-2 text-base text-gray-500">
                    <p>1102 R Street</p>
                    <p className="mt-1">Suite 200</p>
                    <p className="mt-1">Sacramento, CA 95811</p>
                  </div>
                </div>
                {/* <div>
                  <h3 className="text-lg font-medium leading-6 text-gray-900">
                    New York
                  </h3>
                  <div className="mt-2 text-base text-gray-500">
                    <p>886 Walter Streets</p>
                    <p className="mt-1">New York, NY 12345</p>
                  </div>
                </div> */}
                {/* <div>
                  <h3 className="text-lg font-medium leading-6 text-gray-900">
                    Toronto
                  </h3>
                  <div className="mt-2 text-base text-gray-500">
                    <p>7363 Cynthia Pass</p>
                    <p className="mt-1">Toronto, ON N3Y 4H8</p>
                  </div>
                </div> */}
                {/* <div>
                  <h3 className="text-lg font-medium leading-6 text-gray-900">
                    Chicago
                  </h3>
                  <div className="mt-2 text-base text-gray-500">
                    <p>726 Mavis Island</p>
                    <p className="mt-1">Chicago, IL 60601</p>
                  </div>
                </div> */}
              </div>
            </div>

            <div className="mt-6 pt-8">
              <a
                className="body-link font-normal"
                href="https://action.governforcalifornia.org/a/subscribe"
                target="_blank"
                rel="noreferrer"
              >
                Subscribe to GFC
                <ExternalLinkIcon
                  className="ml-[3px] inline h-3"
                  aria-hidden="true"
                />
              </a>
            </div>
            <div className="pt-2">
              <a
                className="body-link font-normal"
                href="https://action.governforcalifornia.org/a/self_service"
                target="_blank"
                rel="noreferrer"
              >
                GFC supporter login
                <ExternalLinkIcon
                  className="ml-[3px] inline h-3"
                  aria-hidden="true"
                />
              </a>
            </div>
          </div>
        </SectionContainer>
      </Layout>
    </>
  );
}
